import _classCallCheck from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _inherits from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _wrapNativeSuper from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/wrapNativeSuper";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

import auth from './auth';
import db from './db';
import config from './config';
import payments from './payments';
import statusCodes from '../statusCodes';

var AppIdNotSet = /*#__PURE__*/function (_Error) {
  _inherits(AppIdNotSet, _Error);

  var _super = _createSuper(AppIdNotSet);

  function AppIdNotSet() {
    var _this;

    _classCallCheck(this, AppIdNotSet);

    for (var _len = arguments.length, params = new Array(_len), _key = 0; _key < _len; _key++) {
      params[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(params));
    _this.name = 'AppIdNotSet';
    _this.message = 'App ID not set yet. Make sure to configure app ID.';
    _this.status = statusCodes['Bad Request'];
    return _this;
  }

  return AppIdNotSet;
}( /*#__PURE__*/_wrapNativeSuper(Error));

var ServiceUnavailable = /*#__PURE__*/function (_Error2) {
  _inherits(ServiceUnavailable, _Error2);

  var _super2 = _createSuper(ServiceUnavailable);

  function ServiceUnavailable() {
    var _this2;

    _classCallCheck(this, ServiceUnavailable);

    for (var _len2 = arguments.length, params = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
      params[_key2] = arguments[_key2];
    }

    _this2 = _super2.call.apply(_super2, [this].concat(params));
    _this2.name = 'ServiceUnavailable';
    _this2.message = 'Service unavailable.';
    _this2.status = statusCodes['Service Unavailable'];
    return _this2;
  }

  return ServiceUnavailable;
}( /*#__PURE__*/_wrapNativeSuper(Error));

var InternalServerError = /*#__PURE__*/function (_ServiceUnavailable) {
  _inherits(InternalServerError, _ServiceUnavailable);

  var _super3 = _createSuper(InternalServerError);

  function InternalServerError() {
    var _this3;

    _classCallCheck(this, InternalServerError);

    for (var _len3 = arguments.length, params = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
      params[_key3] = arguments[_key3];
    }

    _this3 = _super3.call.apply(_super3, [this].concat(params));
    _this3.status = statusCodes['Internal Server Error'];
    return _this3;
  }

  return InternalServerError;
}(ServiceUnavailable);

var Timeout = /*#__PURE__*/function (_ServiceUnavailable2) {
  _inherits(Timeout, _ServiceUnavailable2);

  var _super4 = _createSuper(Timeout);

  function Timeout() {
    var _this4;

    _classCallCheck(this, Timeout);

    for (var _len4 = arguments.length, params = new Array(_len4), _key4 = 0; _key4 < _len4; _key4++) {
      params[_key4] = arguments[_key4];
    }

    _this4 = _super4.call.apply(_super4, [this].concat(params));
    _this4.status = statusCodes['Gateway Timeout'];
    return _this4;
  }

  return Timeout;
}(ServiceUnavailable);

var Reconnecting = /*#__PURE__*/function (_ServiceUnavailable3) {
  _inherits(Reconnecting, _ServiceUnavailable3);

  var _super5 = _createSuper(Reconnecting);

  function Reconnecting() {
    var _this5;

    _classCallCheck(this, Reconnecting);

    for (var _len5 = arguments.length, params = new Array(_len5), _key5 = 0; _key5 < _len5; _key5++) {
      params[_key5] = arguments[_key5];
    }

    _this5 = _super5.call.apply(_super5, [this].concat(params));
    _this5.message = 'Reconnecting.';
    return _this5;
  }

  return Reconnecting;
}(ServiceUnavailable);

var UnknownServiceUnavailable = /*#__PURE__*/function (_ServiceUnavailable4) {
  _inherits(UnknownServiceUnavailable, _ServiceUnavailable4);

  var _super6 = _createSuper(UnknownServiceUnavailable);

  function UnknownServiceUnavailable(e) {
    var _this6;

    _classCallCheck(this, UnknownServiceUnavailable);

    for (var _len6 = arguments.length, params = new Array(_len6 > 1 ? _len6 - 1 : 0), _key6 = 1; _key6 < _len6; _key6++) {
      params[_key6 - 1] = arguments[_key6];
    }

    _this6 = _super6.call.apply(_super6, [this, e].concat(params));
    console.error('Userbase error. Please report this to support@userbase.com.\n\n', e);
    return _this6;
  }

  return UnknownServiceUnavailable;
}(ServiceUnavailable);

var ParamsMustBeObject = /*#__PURE__*/function (_Error3) {
  _inherits(ParamsMustBeObject, _Error3);

  var _super7 = _createSuper(ParamsMustBeObject);

  function ParamsMustBeObject() {
    var _this7;

    _classCallCheck(this, ParamsMustBeObject);

    for (var _len7 = arguments.length, params = new Array(_len7), _key7 = 0; _key7 < _len7; _key7++) {
      params[_key7] = arguments[_key7];
    }

    _this7 = _super7.call.apply(_super7, [this].concat(params));
    _this7.name = 'ParamsMustBeObject';
    _this7.message = 'Parameters passed to function must be placed inside an object.';
    _this7.status = statusCodes['Bad Request'];
    return _this7;
  }

  return ParamsMustBeObject;
}( /*#__PURE__*/_wrapNativeSuper(Error));

var TooManyRequests = /*#__PURE__*/function (_Error4) {
  _inherits(TooManyRequests, _Error4);

  var _super8 = _createSuper(TooManyRequests);

  function TooManyRequests(retryDelay) {
    var _this8;

    _classCallCheck(this, TooManyRequests);

    for (var _len8 = arguments.length, params = new Array(_len8 > 1 ? _len8 - 1 : 0), _key8 = 1; _key8 < _len8; _key8++) {
      params[_key8 - 1] = arguments[_key8];
    }

    _this8 = _super8.call.apply(_super8, [this, retryDelay].concat(params));
    var retryDelaySeconds = Math.floor(retryDelay / 1000);
    _this8.name = 'TooManyRequests';
    _this8.message = "Too many requests in a row. Please try again in ".concat(retryDelaySeconds, " second").concat(retryDelaySeconds !== 1 ? 's' : '', ".");
    _this8.status = statusCodes['Too Many Requests'];
    return _this8;
  }

  return TooManyRequests;
}( /*#__PURE__*/_wrapNativeSuper(Error));

export default _objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread({}, auth), db), config), payments), {}, {
  AppIdNotSet: AppIdNotSet,
  InternalServerError: InternalServerError,
  ServiceUnavailable: ServiceUnavailable,
  Timeout: Timeout,
  Reconnecting: Reconnecting,
  UnknownServiceUnavailable: UnknownServiceUnavailable,
  ParamsMustBeObject: ParamsMustBeObject,
  TooManyRequests: TooManyRequests
});